var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5ZM6.28252 13.7506C5.56057 12.2194 5.11799 10.5307 5.02048 8.75H2.04642C2.3435 11.1324 4.03729 13.081 6.28252 13.7506ZM6.52302 8.75C6.63582 10.5791 7.15835 12.2973 8 13.814C8.84165 12.2973 9.36417 10.5791 9.47698 8.75H6.52302ZM13.9536 8.75H10.9795C10.882 10.5307 10.4395 12.2194 9.7175 13.7506C11.9627 13.081 13.6565 11.1324 13.9536 8.75ZM2.04642 7.25H5.02048C5.11799 5.46933 5.56057 3.78055 6.28252 2.24942C4.03729 2.919 2.3435 4.86762 2.04642 7.25ZM6.52302 7.25H9.47698C9.36417 5.42092 8.84165 3.70269 8 2.18599C7.15835 3.70269 6.63582 5.42092 6.52302 7.25ZM9.7175 2.24942C10.4395 3.78055 10.882 5.46933 10.9795 7.25H13.9536C13.6565 4.86762 11.9627 2.919 9.7175 2.24942Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/region.c9866935538e3129e3ef7053ad1b5c6e.svg";
export { ForwardRef as ReactComponent };